export default {
  computed: {
    widths() {
      return {
        'WIDTH_1_12': {
          value: 1,
          classes: {
            phone: [
              {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
            ],
            tablet: [
              {property: 'ColumnWidth', value: 'WIDTH_1_12', touched: false}
            ],
            desktop: [
              {property: 'ColumnWidth', value: 'WIDTH_1_12', touched: false}
            ]
          },
          maxPercentageSize: .083
        },
        'WIDTH_2_12': {
          value: 2,
          classes: {
            phone: [
              {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
            ],
            tablet: [
              {property: 'ColumnWidth', value: 'WIDTH_2_12', touched: false}
            ],
            desktop: [
              {property: 'ColumnWidth', value: 'WIDTH_2_12', touched: false}
            ]
          },
          maxPercentageSize: .167
        },
        'WIDTH_3_12': {
          value: 3,
          classes: {
            phone: [
              {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
            ],
            tablet: [
              {property: 'ColumnWidth', value: 'WIDTH_3_12', touched: false}
            ],
            desktop: [
              {property: 'ColumnWidth', value: 'WIDTH_3_12', touched: false}
            ]
          },
          maxPercentageSize: .25
        },
        'WIDTH_4_12': {
          value: 4,
          classes: {
            phone: [
              {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
            ],
            tablet: [
              {property: 'ColumnWidth', value: 'WIDTH_4_12', touched: false}
            ],
            desktop: [
              {property: 'ColumnWidth', value: 'WIDTH_4_12', touched: false}
            ]
          },
          maxPercentageSize: .333
        },
        'WIDTH_5_12': {
          value: 5,
          classes: {
            phone: [
              {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
            ],
            tablet: [
              {property: 'ColumnWidth', value: 'WIDTH_5_12', touched: false}
            ],
            desktop: [
              {property: 'ColumnWidth', value: 'WIDTH_5_12', touched: false}
            ]
          },
          maxPercentageSize: .416
        },
        'WIDTH_6_12': {
          value: 6,
          classes: {
            phone: [
              {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
            ],
            tablet: [
              {property: 'ColumnWidth', value: 'WIDTH_6_12', touched: false}
            ],
            desktop: [
              {property: 'ColumnWidth', value: 'WIDTH_6_12', touched: false}
            ]
          },
          maxPercentageSize: .5
        },
        'WIDTH_7_12': {
          value: 7,
          classes: {
            phone: [
              {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
            ],
            tablet: [
              {property: 'ColumnWidth', value: 'WIDTH_7_12', touched: false}
            ],
            desktop: [
              {property: 'ColumnWidth', value: 'WIDTH_7_12', touched: false}
            ]
          },
          maxPercentageSize: .583
        },
        'WIDTH_8_12': {
          value: 8,
          classes: {
            phone: [
              {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
            ],
            tablet: [
              {property: 'ColumnWidth', value: 'WIDTH_8_12', touched: false}
            ],
            desktop: [
              {property: 'ColumnWidth', value: 'WIDTH_8_12', touched: false}
            ]
          },
          maxPercentageSize: .66
        },
        'WIDTH_9_12': {
          value: 9,
          classes: {
            phone: [
              {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
            ],
            tablet: [
              {property: 'ColumnWidth', value: 'WIDTH_9_12', touched: false}
            ],
            desktop: [
              {property: 'ColumnWidth', value: 'WIDTH_9_12', touched: false}
            ]
          },
          maxPercentageSize: .75
        },
        'WIDTH_10_12': {
          value: 10,
          classes: {
            phone: [
              {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
            ],
            tablet: [
              {property: 'ColumnWidth', value: 'WIDTH_10_12', touched: false}
            ],
            desktop: [
              {property: 'ColumnWidth', value: 'WIDTH_10_12', touched: false}
            ]
          },
          maxPercentageSize: .833
        },
        'WIDTH_11_12': {
          value: 11,
          classes: {
            phone: [
              {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
            ],
            tablet: [
              {property: 'ColumnWidth', value: 'WIDTH_11_12', touched: false}
            ],
            desktop: [
              {property: 'ColumnWidth', value: 'WIDTH_11_12', touched: false}
            ]
          },
          maxPercentageSize: .916
        },
        'WIDTH_12_12': {
          value: 12,
          classes: {
            phone: [
              {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
            ],
            tablet: [
              {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
            ],
            desktop: [
              {property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false}
            ]
          },
          maxPercentageSize: 1
        }
      }
    },

    allWidthClasses() {
      let classes = Object.keys(this.widths).reduce((carry, width) => {
        return [...carry, ...this.widths[width].classes]
      }, new Array)
      return new Array(...new Set(classes))
    },
  },

  methods: {
    getWidthClasses(width) {
      let widthFound = Object.keys(this.widths).find(availableWidth => {
        return width <= this.widths[availableWidth].maxPercentageSize
      })
      if (! widthFound) {
        return this.widths['WIDTH_12_12'].value
      }
      return this.widths[widthFound].value
    }
  }
}